const stripSF = (s) => String(s || '').replace(/^SF /, '').trim();

/** The allergy groups an `allergenConflicts` list clashes with ("Tree Nuts,
 *  Dairy"), deduped. Falls back to ingredient names when no group resolves (stale
 *  payload, or a free-text exclusion with no linked record) — naming something
 *  beats an unexplained warning. */
export function allergenConflictLabel(allergenConflicts = []) {
  const groups = [];
  const ingredients = [];

  (allergenConflicts || []).forEach((conflict) => {
    const labels = (conflict?.labels || []).map(stripSF).filter(Boolean);
    if (labels.length) groups.push(...labels);
    else if (conflict?.name) ingredients.push(stripSF(conflict.name));
  });

  const parts = groups.length ? groups : ingredients;
  return [...new Set(parts)].filter(Boolean).join(', ');
}

/** The conflicting ingredients themselves ("Almonds, Feta"), named the way the
 *  menu names them rather than by their internal "SF …" record name. */
export function conflictIngredientNames(allergenConflicts = []) {
  const names = (allergenConflicts || [])
    .map((conflict) => stripSF(conflict?.name))
    .filter(Boolean);
  return [...new Set(names)].join(', ');
}
